import React, { useState, useEffect } from 'react';
import ReactorHub from './components/ReactorHub';
import ModernAdminDashboard from './components/ModernAdminDashboard';
import GoogleAuthCallback from './components/GoogleAuthCallback';
import { authAPI } from './services/api';
import './App.css';

function RateLimitBanner({ onDismiss }) {
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99999,
      backgroundColor: '#EF4444', color: 'white',
      padding: '12px 20px', textAlign: 'center', fontSize: '14px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px'
    }}>
      <span>You're sending too many requests. Please wait a few minutes before trying again.</span>
      <button onClick={onDismiss} style={{
        background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white',
        borderRadius: '4px', padding: '4px 10px', cursor: 'pointer', fontSize: '13px'
      }}>Dismiss</button>
    </div>
  );
}

function AdminRoute() {
  const [status, setStatus] = useState('checking'); // 'checking' | 'authorized' | 'denied'

  useEffect(() => {
    authAPI.getCurrentUser()
      .then(data => {
        if (data?.account?.role === 'admin') {
          setStatus('authorized');
        } else {
          setStatus('denied');
        }
      })
      .catch(() => setStatus('denied'));
  }, []);

  if (status === 'checking') return null;
  if (status === 'denied') {
    window.location.replace('/');
    return null;
  }
  return <ModernAdminDashboard />;
}

function App() {
  const [rateLimited, setRateLimited] = useState(false);
  const path = window.location.pathname;

  useEffect(() => {
    const handler = () => setRateLimited(true);
    window.addEventListener('reactorhub:ratelimit', handler);
    return () => window.removeEventListener('reactorhub:ratelimit', handler);
  }, []);

  if (path === '/auth/callback') return <GoogleAuthCallback />;
  if (path === '/admin') return <AdminRoute />;

  return (
    <>
      {rateLimited && <RateLimitBanner onDismiss={() => setRateLimited(false)} />}
      <ReactorHub />
    </>
  );
}

export default App;